module.exports = __webpack_public_path__ + "static/tech21.4f813c73.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/carousel/technika/tech21.jpg
// module id = 686
// module chunks = 39862026607597